export const convertToNumber = (value: unknown): number | undefined => {
  if (value === undefined || value === null || (typeof value === "string" && !value.trim())) {
    return undefined;
  }

  const result = Number(value);
  return Number.isNaN(result) ? undefined : result;
};

export const clampNumber = (value: number, minimum: number, maximum: number): number =>
  Math.min(Math.max(value, minimum), maximum);
